export interface SurgeryLocation {
  id: number;
  name: string;
  address: string;
}
